const FEED_PANEL_SELECTED = 'FEED_PANEL_SELECTED';
const APP_STORE_NAVIGATED = 'APP_STORE_NAVIGATED';

export { FEED_PANEL_SELECTED, APP_STORE_NAVIGATED };
